import { render, staticRenderFns } from "./LogoGOV.vue?vue&type=template&id=7ab66994"
import script from "./LogoGOV.vue?vue&type=script&lang=js"
export * from "./LogoGOV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports